import { Col, Empty, Row, Skeleton } from 'antd';
import { Auction } from 'models/auction/Auction';
import { memo } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import AuctionCard from './AuctionCard';

import styles from './InfiniteAuctionList.module.css';
import { useWindowSize } from 'usehooks-ts';
import Title from 'pages/common/components/title/Title';

interface InfiniteAuctionListProps {
  title?: string;
  auctions: Auction[];
  loadMore: () => void;
  hasMore: boolean;
}

function InfiniteAuctionList({ title, auctions, loadMore, hasMore }: InfiniteAuctionListProps) {
  const { width: windowWidth } = useWindowSize();

  const isLargeDevice = windowWidth >= 2100;
  const isDesktop = windowWidth >= 1080;
  const isTablet = windowWidth >= 550;

  // default is mobile
  let columnCount = 1;
  let gutter: [number, number] = [12, 12];

  if (isLargeDevice) {
    columnCount = 3;
    gutter = [24, 24];
  } else if (isDesktop) {
    columnCount = 2;
    gutter = [24, 24];
  } else if (isTablet) {
    columnCount = 1;
    gutter = [24, 24];
  }

  return (
    <>
      {title && (
        <Title className={styles.title} level={1}>
          {title}
        </Title>
      )}

      <InfiniteScroll loadMore={loadMore} hasMore={hasMore} loader={<Skeleton active />}>
        <Row gutter={gutter} justify="center" align="stretch" style={{ marginBottom: gutter[1] }}>
          {auctions.map((auction) => (
            <Col className={styles.card} key={auction.id} span={24 / columnCount}>
              <AuctionCard auctionSummary={auction} />
            </Col>
          ))}
        </Row>
      </InfiniteScroll>

      {!hasMore && auctions.length === 0 && (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="경매가 존재하지 않습니다" />
      )}
    </>
  );
}

export default memo(InfiniteAuctionList);
